import React from "react";
import { Button, CircularProgress, ButtonProps } from "@mui/material";

type Props = {
	text: string | React.ReactNode;
	loading: boolean;
} & ButtonProps;

const ButtonComponent = ({ text, disabled, loading, ...rest }: Props) => {
	return (
		<Button disabled={disabled} {...rest}>
			{loading && <CircularProgress size={10} sx={{ margin: "0 5px" }} />}
			{text}
		</Button>
	);
};

export default ButtonComponent;
